import { isAccessorNode, isFunctionAssignmentNode, isOperatorNode, isSymbolNode, } from "mathjs";
import { cache } from "../../cache";
import { electricalEvaluationMathjs, mechanicalEvaluationMathjs } from "./Evaluators";
import { electricalExpressionScopeGlobals, mechanicalExpressionScopeGlobals, } from "./expression_context/ExpressionContextSystemFunctions";
import { isExpression, removeExpressionPrefix } from "./ExpressionEvaluationHelpers";
export function getElectricalExpressionDependencies(expression) {
    return getExpressionDependencies("electrical", expression);
}
export function getMechanicalExpressionDependencies(expression) {
    return getExpressionDependencies("mechanical", expression);
}
export function getExpressionDependencies(type, expression) {
    return cache(() => {
        if (!isExpression(expression)) {
            return;
        }
        const rawExpression = removeExpressionPrefix(expression);
        try {
            const evaluator = {
                mechanical: mechanicalEvaluationMathjs,
                electrical: electricalEvaluationMathjs,
            }[type];
            const getGlobals = {
                mechanical: mechanicalExpressionScopeGlobals,
                electrical: electricalExpressionScopeGlobals,
            }[type];
            const parsedExpressionNodes = evaluator.parse(rawExpression);
            const computedDeps = computeDependencies(parsedExpressionNodes);
            const globalsContextDeps = getGlobals({}).globalsContextDeps;
            // eslint-disable-next-line @buildwithflux/no-array-foreach
            computedDeps.forEach((dep) => {
                if (globalsContextDeps[dep]) {
                    computedDeps.push(...globalsContextDeps[dep]);
                }
            });
            return computedDeps;
        }
        catch {
            return;
        }
    }, "getExpressionDependencies", [expression, type]);
}
function computeDependencies(parsedExpressionNodes) {
    const dependencies = fetchScopeDependencyPaths(parsedExpressionNodes);
    return flattenDependencies(dependencies);
}
function flattenDependencies(dependencies) {
    const deps = Object.values(dependencies).map((dep) => dep.join("."));
    // remove duplicates
    return [...new Set(deps)];
}
/**
 * The previous version of the code was checking for the existence of a .name property on a MathNode
 *
 * Not sure what the intent was (e.g. it probably wasn't to collect FunctionAssignmentNode), however for BC, we check
 * here all of the possible types of MathNode that have a name property.
 */
function isNamedNode(node) {
    return !!node && (isAccessorNode(node) || isFunctionAssignmentNode(node) || isSymbolNode(node));
}
/**
 * @see https://github.com/josdejong/mathjs/issues/2619
 */
function isNotAUnitPostFix(parent) {
    return !(isOperatorNode(parent) && parent.op === "*" && parent.implicit);
}
function fetchScopeDependencyPaths(rootNode) {
    const deps = {};
    const nodes = [];
    rootNode.traverse((node, _path, parent) => {
        if (isSymbolNode(node) || isAccessorNode(node)) {
            nodes.push({ node, parent });
        }
    });
    function recursion(symbolNodeName, currentNodeRef, deps) {
        const currentNode = nodes.find((n) => n.node === currentNodeRef);
        const parent = currentNode?.parent;
        if (isNamedNode(parent)) {
            if (isAccessorNode(parent)) {
                deps[symbolNodeName].push(parent.name);
            }
            recursion(symbolNodeName, parent, deps);
        }
    }
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    nodes.forEach(({ node, parent }) => {
        if (isSymbolNode(node) && node.name && isNotAUnitPostFix(parent)) {
            // first level
            deps[node.name] = [node.name];
            if (isAccessorNode(parent) && parent?.name) {
                //second level
                deps[node.name].push(parent.name);
                recursion(node.name, parent, deps);
            }
        }
    });
    return deps;
}
//# sourceMappingURL=expressionDependencyExtractor.js.map